import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import TooltipIcon from '../../../TooltipIcon';
import './style.css';

class DialogHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, children, onClose } = this.props;
    return (
      <div className="v3-dialog-title">
        <div className="v3-dialog-title-text">{title}</div>
        <div className="v3-dialog-title-icons">
          {children || (
            <TooltipIcon
              isFontAwesome
              iconName="times"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              tooltipText={
                <FormattedMessage id="SH_Close" defaultMessage="關閉" />
              }
            />
          )}
        </div>
      </div>
    );
  }
}

DialogHeader.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default DialogHeader;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Dialog/components/DialogHeader/index.js
 **/